import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  header: {
    display: 'flex',
  },
  input: {
    margin: [0, 0, theme.spacing(3), 0],
  },
  total: {
    marginLeft: theme.spacing(2),
    color: theme.palette.colors.teal,
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/Quiz/components/AnnualIncomeQuestion/useStyles.js